import { DashboardEventViewer } from '../../components/skins/dashboard-event-viewer.ts';
import { globalState } from '../../framework/globalState.ts';
import { fetchEventLogs, exportEventLogs, fetchSequenceOfEvents } from '../../services/api.ts';

export default function EventViewerPage() {
  const container = document.createElement("div");
  container.classList.add("parent-container");
  container.innerHTML = new DashboardEventViewer().eventviewerskin();

  const siteWithData = globalState.currentSiteWithData;
  const site = (siteWithData as any)?.site || siteWithData;
  const siteId = site?._id;
  const tbody = container.querySelector("tbody");
  const downloadBtn = container.querySelector('.container-toolbar button:first-of-type') as HTMLButtonElement | null;
  const timeBtn = container.querySelector('.container-toolbar button:nth-of-type(2)') as HTMLButtonElement | null;

  let currentFilters: Record<string, string> = {};
  if (siteId) currentFilters.siteId = siteId;

  async function loadEvents() {
    if (!tbody) return;
    tbody.innerHTML = `<tr><td colspan="11" class="text-center">Loading...</td></tr>`;

    try {
      const events: any = await fetchEventLogs(currentFilters);
      const rows = Array.isArray(events) ? events : events?.data || [];

      if (rows.length === 0) {
        tbody.innerHTML = `<tr><td colspan="11" class="text-center">No events found</td></tr>`;
        return;
      }

      tbody.innerHTML = rows.map((ev: any) => {
        const severity = ev.severity || ev.level || '-';
        const siteName = ev.siteName || site?.name || '-';
        const desc = ev.description || ev.message || '-';
        const state = ev.state || ev.status || '-';
        const source = ev.source || ev.deviceName || '-';
        const startDate = ev.startDate || ev.timestamp ? new Date(ev.startDate || ev.timestamp).toLocaleString() : '-';
        const receptionTime = ev.receptionTime ? new Date(ev.receptionTime).toLocaleString() : startDate;
        const delay = ev.alarmDelay || '0s';
        const duration = ev.duration || '-';
        const energyLoss = ev.energyLosses || '-';
        const ackStatus = ev.acknowledged ? 'Acknowledged' : 'Unacknowledged';
        const sevClass = severity >= 50 ? 'mode-error' : severity >= 30 ? 'mode-maintenance' : 'mode-auto';

        return `<tr>
          <td class="text-left"><span class="mode-badge ${sevClass}">${severity}</span></td>
          <td class="text-left">${siteName}</td>
          <td class="text-left">${desc}</td>
          <td class="text-left">${state}</td>
          <td class="text-left">${source}</td>
          <td class="text-left">${startDate}</td>
          <td class="text-left">${receptionTime}</td>
          <td class="text-left">${delay}</td>
          <td class="text-left">${duration}</td>
          <td class="text-left">${energyLoss}</td>
          <td class="text-left"><span class="mode-badge ${ev.acknowledged ? 'mode-auto' : 'mode-maintenance'}">${ackStatus}</span></td>
        </tr>`;
      }).join('');
    } catch (err: any) {
      console.error('[EventViewer] Load error:', err);
      tbody.innerHTML = `<tr><td colspan="11" class="text-center text-danger">Error loading events</td></tr>`;
    }
  }

  // Download / export
  downloadBtn?.addEventListener('click', async () => {
    try {
      await exportEventLogs(currentFilters);
    } catch (err) {
      console.error('[EventViewer] Export error:', err);
    }
  });

  // SOE toggle
  timeBtn?.addEventListener('click', async () => {
    if (!siteId || !tbody) return;
    tbody.innerHTML = `<tr><td colspan="11" class="text-center">Loading SOE...</td></tr>`;
    try {
      const soe: any = await fetchSequenceOfEvents(siteId);
      const rows = Array.isArray(soe) ? soe : soe?.data || [];
      if (rows.length === 0) {
        tbody.innerHTML = `<tr><td colspan="11" class="text-center">No SOE data</td></tr>`;
        return;
      }
      tbody.innerHTML = rows.map((ev: any) => `<tr>
        <td class="text-left">${ev.severity || '-'}</td>
        <td class="text-left">${ev.siteName || site?.name || '-'}</td>
        <td class="text-left">${ev.description || ev.message || '-'}</td>
        <td class="text-left">${ev.state || '-'}</td>
        <td class="text-left">${ev.source || '-'}</td>
        <td class="text-left">${ev.timestamp ? new Date(ev.timestamp).toLocaleString() : '-'}</td>
        <td class="text-left">-</td><td class="text-left">-</td><td class="text-left">-</td>
        <td class="text-left">-</td><td class="text-left">-</td>
      </tr>`).join('');
    } catch (err) {
      console.error('[EventViewer] SOE error:', err);
      tbody.innerHTML = `<tr><td colspan="11" class="text-center text-danger">Error loading SOE</td></tr>`;
    }
  });

  // Filter dropdown
  requestAnimationFrame(async () => {
    if (container.querySelector('.dropdown')) {
      const { Dropdown } = await import('../../components/dropdown.js');
      new Dropdown();
    }
  });

  // Initial load
  loadEvents();

  return container;
}

